import { PageEnum } from '@/enums/pageEnum';
import { LAYOUT } from '@/router/constant';
import type { AppRouteModule } from '@/router/types';

const Home: AppRouteModule = {
    path: '/home',
    name: PageEnum.HOME,
    component: LAYOUT,
    redirect: '/home/index',
    meta: {
        orderNo: '10',
        icon: 'home',
        title: 'cover',
    },
    children: [
        {
            path: 'index',
            name: PageEnum.COVER,
            component: () => import('@/views/main/home/index.vue'),
            meta: {
                title: 'home',
            },
        },
    ],
};

export default Home;
